/// <amd-module name="VSSUI/Card" />
export { Card } from "./Components/Card/Card";
export { CardContent } from "./Components/Card/CardContent";
export { CardFooter } from "./Components/Card/CardFooter";
export { CustomCard } from "./Components/Card/CustomCard";

export {
    ICardProps,
    ICardContentProps,
    ICardHeaderDescriptionProps,
    ICardFooterProps,
    ICardTitleProps,
    ICustomCardProps
} from "./Components/Card/Card.Props";
